import register from '../../../../global/js/registry';
export default register('o-search-results', () => import(/* webpackMode: "lazy" */ './o-search-results.controller'));
